module.exports = __webpack_public_path__ + "img/icon_arrow01.939c2d50.png";